<template>
    <div class="modal fade" id="delete_person_modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $lang('Usunięcie osoby') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {{ $lang('Czy na pewno chcesz usunąć ') + name + ' ' + surname + '?' }}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default"
                            data-dismiss="modal">{{ $lang('Nie') }}
                    </button>
                    <button class="btn btn-primary" v-on:click="deletePerson" data-dismiss="modal">
                        {{ $lang('Tak') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: 'person-delete-modal',
    mixins: [ShowNotification],
    props: ['person', 'delete_route', 'pre_delete_route'],
    data() {
        return {
            name: (this.person != null ? this.person.name : ''),
            surname: (this.person != null ? this.person.surname : ''),
            id: (this.person != null ? this.person.id : ''),
        }
    },
    watch: {
        person: {
            deep: true,
            handler() {
                if (this.person !== null) {
                    this.id = this.person.id;
                    this.name = this.person.name;
                    this.surname = this.person.surname;
                }
            }
        }
    },
    methods: {
        deletePerson() {
            const self = this;

            axios.post(this.pre_delete_route + '/' + this.id)
                 .then(response => {
                     axios.post(this.delete_route + '/' + this.id)
                          .then(response => {
                              self.$parent.generate(this.$parent.pagination.current_page);
                              self.showNotification('success', 'Pomyślnie usunięto osobę!');

                          })
                          .catch(function (error) {
                              self.showNotification('error', 'Nie udało się usunąć osoby!');
                          });
                 })
                 .catch(function (error) {
                     let status = error.response.status;

                     if (status === 409) {
                         switch (error.response.data.reason) {
                             case 'related_task':
                                 self.showNotification('error', 'Nie można usunąć osoby, która jest powiązana z co najmniej jednym zgłoszeniem! Zdezaktywuj osobę lub skonsultuj się z administratorem systemu.');
                                 break;
                             case 'related_remote_job':
                                 self.showNotification('error', 'Nie można usunąć osoby, która jest powiązana z co najmniej jedną pracą zdalną! Zdezaktywuj osobę lub skonsultuj się z administratorem systemu.');
                                 break;
                             default:
                                 console.log(error);
                         }
                     } else {
                         console.log(error);
                     }
                 });
        }
    }
}
</script>
